<div class="app-container">
    <jft-env-banner></jft-env-banner>
    @if (!adminV2() && !v2() && !access()) {
        <navbar></navbar>
    }
    <loading-indicator></loading-indicator>
    @if (!v2()) {
        <jft-settings-shell></jft-settings-shell>
    }
    <main class="app-main" (scroll)="onScroll($event)">
        <router-outlet></router-outlet>
    </main>
    <app-toasts-container></app-toasts-container>

    <!-- Global Scroll to Top Button. Not under /v2: its fixed z 1050 covered v2's pinned
         bars on a phone, and the v2 shell scrolls in its own container anyway. -->
    @if (!v2()) {
        <button (click)="scrollToTop()"
                class="btn btn-primary rounded-circle shadow-lg scroll-top-btn"
                [class.visible]="showScrollTop"
                title="Scroll to Top">
            <i class="bi bi-chevron-up fs-4"></i>
        </button>
    }
</div>
